import { render, staticRenderFns } from "./ChaoweiPrescriptionPage.vue?vue&type=template&id=13a6c761&scoped=true"
import script from "./ChaoweiPrescriptionPage.vue?vue&type=script&lang=js"
export * from "./ChaoweiPrescriptionPage.vue?vue&type=script&lang=js"
import style0 from "./ChaoweiPrescriptionPage.vue?vue&type=style&index=0&id=13a6c761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6c761",
  null
  
)

export default component.exports